import React from "react";

import Joi from "joi-browser";
import Form from "../common/Form";

import db from "../../services/query";
import lbl from "../../data/Labels.json";

import { PopUpContext } from "../../contexts/popUpContext";

class StudentFeeForm extends Form {
  static contextType = PopUpContext;

  state = {
    drp: {
      accounts: [],
      classes: [],
    },
    data: {
      amount: "",
      payment_date: "",
      student_class_id: "",
      account_id: "",
      bank_ref_no: "",
      remark: "",
    },
    errors: {},
  };

  componentDidMount = async () => {
    const { drp, data } = this.state;
    const {
      popUp: { cache, edit },
    } = this.context;

    if (edit) {
      data.amount = edit.amount;
      data.payment_date = edit.payment_date;
      data.student_class_id = edit.student_class_id;
      data.account_id = edit.account_id;
      data.bank_ref_no = edit.bank_ref_no;
      data.remark = edit.remark;
    }

    await db
      .getAll(`dropdowns/accounts`)
      .then(({ data: { data } }) => (drp["accounts"] = data));

    await db
      .getAll(`dropdowns/studentClasses?studentId=${cache}`)
      .then(({ data: { data } }) => (drp["classes"] = data));

    this.setState({ drp, data });
  };

  schema = {
    amount: Joi.number().required(),
    payment_date: Joi.date().required(),
    student_class_id: Joi.number().required(),
    account_id: Joi.number().required(),
    bank_ref_no: Joi.string().required(),
    remark: Joi.allow(null),
  };

  doSubmit = async () => {
    try {
      const { togglePopUp, popUp } = this.context;

      let props = {
        student_id: popUp?.cache,
        ...this.state.data,
      };

      if (popUp?.edit) {
        await db
          .edit(`students/fees/${popUp.edit.id}`, props)
          .then(() => {
            togglePopUp({ form: "toast" });
          })
          .catch((e) => {
            togglePopUp({
              form: "toast",
              message: e.toString(),
              type: "warning",
            });
          });
      } else {
        await db
          .save("students/fees", props)
          .then(() => {
            togglePopUp({ form: "toast" });
          })
          .catch((e) => {
            togglePopUp({
              form: "toast",
              message: e.toString(),
              type: "warning",
            });
          });
      }
    } catch ({ response }) {
      if (response && response.status === 400) {
        const errors = { ...this.state.error };

        console.log(errors);
        this.setState({ errors });
      }
    }
  };

  render() {
    const { drp } = this.state;
    const { popUp } = this.context;

    return (
      <div className="form-container">
        <form className="form crud" onSubmit={this.handleSubmit}>
          <div className="head">
            <p>{popUp?.edit ? lbl.FeePaymentEdit : lbl.FeePayment}</p>
          </div>
          <div className="form-inputs">
            {this.renderSelect("student_class_id", "سمستر", drp["classes"])}
            {this.renderInput("amount", "مبلغ", "number")}
            {this.renderSelect("account_id", "حساب", drp["accounts"])}
            {this.renderInput("payment_date", "تاریخ پرداخت", "date")}
            {this.renderInput("bank_ref_no", "ریفرنس نمبر")}
            {this.renderInput("remark", "ملاحظه", "textarea")}
          </div>
          <div className="form-buttons">
            {this.renderButton(popUp?.edit ? lbl.Edit : lbl.Save)}
          </div>
        </form>
      </div>
    );
  }
}

export default StudentFeeForm;
